export enum AclRoles {
  Admin = 'ADMIN',
  Basic = 'BASIC',
}
